<template>
  <div class="mt-[6px">
    <a-breadcrumb>
      <template #separator><span class="text-blue-400 text-sm">＞</span></template>
      <a-breadcrumb-item
        :class="{
          'cursor-pointer': !item.notClickable,
          'pointer-events-none': hasShowCursorPointer === item.path
        }"
        v-for="(item, index) in items"
        :key="index"
        @click="handleTapOption(item)"
      >
        <a-space size="small">
          <span
            :class="[
              'text-blue-400',
              { 'font-black': index === items.length - 1, 'font-thin': index < items.length - 1 }
            ]"
          >
            {{ $t(item.title) }}
          </span>
        </a-space>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <a-divider v-if="items.length > 0" class="!mt-1 !mb-5" />
  </div>
</template>
<script lang="ts" setup>
import { useRoute, useRouter } from 'vue-router';
import { computed, onMounted, ref, watch } from 'vue';
import { useContractStore } from '@/stores/modules/contract';

interface Item {
  path: string;
  title: string;
  [key: string]: any;
  notClickable?: boolean;
  noBreadcrumb?: boolean;
}

const props = defineProps<{
  route: any;
}>();

const router = useRouter();
const currentRoute = useRoute();
const items = ref<Item[]>([]);
const contractStore = useContractStore();

const updateBreadcrumbItems = () => {
  items.value = currentRoute.matched?.map((val) => ({
    path: val.path,
    title: val.meta.title as string,
    notClickable: val.meta.notClickable,
    noBreadcrumb: val.meta.noBreadcrumb
  }));
  // if some items have the same path, remove the duplicated items
  items.value = items.value
    .filter((val, index, self) => self.findIndex((t) => t.path === val.path) === index)
    .filter((val) => !val.noBreadcrumb);
};

const hasShowCursorPointer = computed(() => {
  return currentRoute.matched[currentRoute.matched.length - 1].path;
});

const handleTapOption = ({ path, notClickable }: Item) => {
  if (notClickable) return;
  if (path.includes('contract-create')) {
    handleContractRoute();
  } else {
    if (currentRoute.matched[currentRoute.matched.length - 1].path === path) return;
    router.push({ path });
  }
};

const handleContractRoute = () => {
  router.push({ path: '/contract-create/' + contractStore.project.id });
};

watch(() => currentRoute.fullPath, updateBreadcrumbItems);

onMounted(() => {
  updateBreadcrumbItems();
});
</script>
